import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';

export const getEncounterStartDate = (
  encounter: TranscriptorEncounterResponse,
) => new Date(encounter.started_at ?? encounter.created_at);
